module.exports = __webpack_public_path__ + "static/media/Group_1597880794@2x.d9458d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Group_1597880794@2x.png
// module id = 1750
// module chunks = 0